import { IVehicleStyleDetail } from '../types/IVehicleStyle';

export const AVAILABLE_DRIVES = [
    { value: '2WD', label: '2 Wheel Drive', code: '2WD' },
    { value: '4WD/AWD', label: '4 Wheel Drive/All Wheel Drive', code: '4WD' },
];

export const AVAILABLE_TRANSMISSIONS = [
    { value: 'Automatic', label: 'Automatic' },
    { value: 'Manual', label: 'Manual' },
];

export const AVAILABLE_FUELS = [
    { value: 'Gas', label: 'Gas' },
    { value: 'Diesel', label: 'Diesel' },
];

export const skuGroupToUniqueStyles = (skuGroup: IVehicleStyleDetail[]) => {
    const transmissions = new Set<string>();
    const drives = new Set<string>();
    const fuels = new Set<string>();

    for (const sku of skuGroup) {
        const { transmission, drive, fuel } = sku;
        const matchedTransmission = AVAILABLE_TRANSMISSIONS.find(option =>
            transmission.display?.includes(option.value)
        );
        if (matchedTransmission) transmissions.add(matchedTransmission.value);
        if (AVAILABLE_DRIVES.some(option => option.value === drive.display)) drives.add(drive.display);
        if (AVAILABLE_FUELS.some(option => option.value === fuel.display)) fuels.add(fuel.display);
    }

    return {
        drives: Array.from(drives),
        transmissions: Array.from(transmissions),
        fuels: Array.from(fuels),
    };
};

// Finds the skuGroups best matching sku based on drive, transmission, and fuel
export const findMatchingSku = (
    skuGroup: IVehicleStyleDetail[],
    drive: string,
    transmission: string,
    fuel?: string
) => {
    // Default to first sku
    let match = skuGroup[0];
    let matchScore = 0;
    for (const sku of skuGroup) {
        const fuelMatch = sku.fuel.display == fuel;
        const driveMatch = sku.drive.display == drive;
        const transmissionMatch = sku.transmission.display?.includes(transmission);

        let skuScore = 0;

        if (transmissionMatch) {
            skuScore += 2;
        }
        if (driveMatch) {
            skuScore += 2;
        }

        // Fuel score lower to act as a tie-breaker (i.e drive+transmission match > drive+fuel match)
        if (fuelMatch) {
            skuScore += 1;
        }

        if (skuScore > matchScore) {
            match = sku;
            matchScore = skuScore;
        }
    }

    return match;
};

// Adds or removes option code from array
export const toggleStyleOption = (options: string[], value: string) => {
    const newOptions = new Set(options);
    if (newOptions.has(value)) newOptions.delete(value);
    else newOptions.add(value);
    return Array.from(newOptions);
};
